import React from "react";
import { Link } from "react-router-dom";

function Collectible() {
  return (
    <>
      <div class="container">
        {/* <!-- explore --> */}
        <section class="row row--grid">
          {/* <!-- title --> */}
          <div class="col-12">
            <div class="main__title">
              <h2> Curated Chords</h2>
            </div>
          </div>
          {/* <!-- end title --> */}

          {/* <!-- tabs nav --> */}
          {/* <div class="col-12">
					<ul class="nav nav-tabs main__tabs" id="main__tabs" role="tablist">
						<li class="nav-item">
							<a class="nav-link active" data-toggle="tab" href="#tab-1" role="tab" aria-controls="tab-1" aria-selected="true">All</a>
						</li>

						<li class="nav-item">
							<a class="nav-link" data-toggle="tab" href="#tab-2" role="tab" aria-controls="tab-2" aria-selected="false">Art</a>
						</li>

						<li class="nav-item">
							<a class="nav-link" data-toggle="tab" href="#tab-3" role="tab" aria-controls="tab-3" aria-selected="false">Photography</a>
						</li>

						<li class="nav-item">
							<a class="nav-link" data-toggle="tab" href="#tab-4" role="tab" aria-controls="tab-4" aria-selected="false">Memes</a>
						</li>
					</ul>
				</div> */}
          {/* <!-- end tabs nav --> */}

          <div class="col-12">
            {/* <!-- tabs content --> */}
            <div class="tab-content">
              <div class="tab-pane fade show active" id="tab-1" role="tabpanel">
                <div class="row row--grid">
                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- card --> */}
                    <div class="card">
                      <Link to="/item" class="card__cover">
                        <img src="/images/cover1.jpg" alt="" />
                      </Link>
                      <h3 class="card__title">
                        <Link to="/item">Walking on Air</Link>
                      </h3>
                      <div class="card__author">
                        <img src="/images/seller4.jpg" alt="" />
                        <Link to="/author">@nickname</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Reserve price</span>
                          <span>4.89 ETH</span>
                        </div>

                        <button class="card__likes" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span>189</span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end card --> */}
                  </div>

                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- carousel card --> */}
                    <div class="card">
                      <div class="card__cover card__cover--carousel owl-carousel">
                        <img src="/images/cover2.jpg" alt="" />
                        <img src="/images/cover2.jpg" alt="" />
                        <img src="/images/cover2.jpg" alt="" />
                      </div>

                      <h3 class="card__title">
                        <Link to="/item">To Infinity And Beyond</Link>
                      </h3>
                      <div class="card__author card__author--verified">
                        <img src="images/avatar2.jpg" alt="" />
                        <Link to="/author">@johndoe</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Reserve price</span>
                          <span>5.04 ETH</span>
                        </div>

                        <button class="card__likes" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span></span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end carousel card --> */}
                  </div>

                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- card --> */}
                    <div class="card">
                      <Link to="/item" class="card__cover">
                        <img src="/images/cover3.jpg" alt="" />
                      </Link>
                      <h3 class="card__title">
                        <a href="item.html">
                          Les Immortels, the Treachery of Artificial Shadows
                        </a>
                      </h3>
                      <div class="card__author card__author--verified">
                        <img src="/images/avatar3.jpg" alt="" />
                        <Link to="/author">@neo</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Current price</span>
                          <span>2.61 ETH</span>
                        </div>

                        <button class="card__likes" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span>702</span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end card --> */}
                  </div>

                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- card --> */}
                    <div class="card">
                      <Link to="/item" class="card__cover">
                        <img src="/images/cover8.jpg" alt="" />
                      </Link>
                      <h3 class="card__title">
                        <Link to="/item">
                          Flowers in Concrete (Modal)
                        </Link>
                      </h3>
                      <div class="card__author">
                        <img src="/images/seller2.jpg" alt="" />
                        <Link to="/author">@min1max</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Reserve price</span>
                          <span>3.19 ETH</span>
                        </div>

                        <button
                          class="card__likes card__likes--active"
                          type="button"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span>37</span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end card --> */}
                  </div>

                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- card --> */}
                    <div class="card">
                      <a href="item.html" class="card__cover">
                        <img src="/images/cover4.jpg" alt="" />
                      </a>
                      <h3 class="card__title">
                        <a href="item.html">Industrial Revolution</a>
                      </h3>
                      <div class="card__author card__author--verified">
                        <img src="/images/seller5.jpg" alt="" />
                        <Link to="/author">@midinh</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Reserve price</span>
                          <span>1.11 ETH</span>
                        </div>

                        <button class="card__likes" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span>23</span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end card --> */}
                  </div>

                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- card --> */}
                    <div class="card">
                      <a href="item.html" class="card__cover">
                        <img src="/images/cover5.jpg" alt="" />
                        {/* <span class="card__time">15 minutes left</span> */}
                      </a>
                      <h3 class="card__title">
                        <a href="item.html">I Love You</a>
                      </h3>
                      <div class="card__author card__author--verified">
                        <img src="/images/seller9.jpg" alt="" />
                        <Link to="/author">@nicky87</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Current price</span>
                          <span>0.99 ETH</span>
                        </div>

                        <button class="card__likes" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span>358</span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end card --> */}
                  </div>

                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- video card --> */}
                    <div class="card">
                      <a
                        href="item.html"
                        class="card__cover card__cover--video"
                      >
                        <img src="/images/cover6.jpg" alt="" />
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                        >
                          <path d="M21.53,7.15a1,1,0,0,0-1,0L17,8.89A3,3,0,0,0,14,6H5A3,3,0,0,0,2,9v6a3,3,0,0,0,3,3h9a3,3,0,0,0,3-2.89l3.56,1.78A1,1,0,0,0,21,17a1,1,0,0,0,.53-.15A1,1,0,0,0,22,16V8A1,1,0,0,0,21.53,7.15ZM15,15a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V9A1,1,0,0,1,5,8h9a1,1,0,0,1,1,1Zm5-.62-3-1.5V11.12l3-1.5Z" />
                        </svg>
                      </a>
                      <h3 class="card__title">
                        <a href="item.html">Walking on Air</a>
                      </h3>
                      <div class="card__author">
                        <img src="/images/seller10.jpg" alt="" />
                        <Link to="/author">@redalert</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Reserve price</span>
                          <span>1.63 ETH</span>
                        </div>

                        <button class="card__likes" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span>90</span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end video card --> */}
                  </div>

                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- card --> */}
                    <div class="card">
                      <a href="item.html" class="card__cover">
                        <img src="/images/cover7.jpg" alt="" />
                      </a>
                      <h3 class="card__title">
                        <a href="item.html">Tranquility</a>
                      </h3>
                      <div class="card__author">
                        <img src="/images/seller11.jpg" alt="" />
                        <Link to="/author">@aaarthur</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Reserve price</span>
                          <span>2.55 ETH</span>
                        </div>

                        <button class="card__likes" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span>64</span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end card --> */}
                  </div>
                </div>

                {/* <!-- paginator --> */}
                {/* <div class="row row--grid">
								<div class="col-12">
									<div class="paginator">
										<span class="paginator__pages">9 from 169</span>

										<ul class="paginator__list">
											<li>
												<a href="/"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M17,11H9.41l3.3-3.29a1,1,0,1,0-1.42-1.42l-5,5a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l5,5a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H17a1,1,0,0,0,0-2Z"/></svg></a>
											</li>
											<li class="active"><a href="/">1</a></li>
											<li><a href="/">2</a></li>
											<li><a href="/">3</a></li>
											<li><a href="/">4</a></li>
											<li>
												<a href="/"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M17.92,11.62a1,1,0,0,0-.21-.33l-5-5a1,1,0,0,0-1.42,1.42L14.59,11H7a1,1,0,0,0,0,2h7.59l-3.3,3.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l5-5a1,1,0,0,0,.21-.33A1,1,0,0,0,17.92,11.62Z"/></svg></a>
											</li>
										</ul>
									</div>
								</div>
							</div>
							{/* <!-- end paginator --> */}
              </div>

              <div class="tab-pane fade" id="tab-2" role="tabpanel">
                <div class="row row--grid">
                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- card --> */}
                    <div class="card">
                      <a href="item.html" class="card__cover">
                        <img src="/images/cover7.jpg" alt="" />
                      </a>
                      <h3 class="card__title">
                        <a href="item.html">Walking on Air</a>
                      </h3>
                      <div class="card__author">
                        <img src="/images/seller2.jpg" alt="" />
                        <Link to="/author">@nickname</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Reserve price</span>
                          <span>4.89 ETH</span>
                        </div>

                        <button class="card__likes" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span>189</span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end card --> */}
                  </div>

                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- card --> */}
                    <div class="card">
                      <a href="item.html" class="card__cover">
                        <img src="/images/cover6.jpg" alt="" />
                      </a>
                      <h3 class="card__title">
                        <a href="item.html">
                          Les Immortels, the Treachery of Artificial Shadows
                        </a>
                      </h3>
                      <div class="card__author card__author--verified">
                        <img src="/images/seller3.jpg" alt="" />
                        <Link to="/author">@neo</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Reserve price</span>
                          <span>2.61 ETH</span>
                        </div>

                        <button class="card__likes" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span>702</span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end card --> */}
                  </div>

                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- card --> */}
                    <div class="card">
                      <a href="item.html" class="card__cover">
                        <img src="/images/cover8.jpg" alt="" />
                        <span class="card__time">15 minutes left</span>
                      </a>
                      <h3 class="card__title">
                        <a href="item.html">To Infinity And Beyond</a>
                      </h3>
                      <div class="card__author card__author--verified">
                        <img src="/images/seller2.jpg" alt="" />
                        <Link to="/author">@johndoe</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Current price</span>
                          <span>5.04 ETH</span>
                        </div>

                        <button class="card__likes" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span></span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end card --> */}
                  </div>

                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- card --> */}
                    <div class="card">
                      <a href="item.html" class="card__cover">
                        <img src="/images/cover5.jpg" alt="" />
                      </a>
                      <h3 class="card__title">
                        <a href="item.html">Flowers in Concrete</a>
                      </h3>
                      <div class="card__author">
                        <img src="/images/seller4.jpg" alt="" />
                        <Link to="/author">@min1max</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Reserve price</span>
                          <span>3.19 ETH</span>
                        </div>

                        <button
                          class="card__likes card__likes--active"
                          type="button"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span>37</span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end card --> */}
                  </div>

                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- card --> */}
                    <div class="card">
                      <a href="item.html" class="card__cover">
                        <img src="/images/cover4.jpg" alt="" />
                      </a>
                      <h3 class="card__title">
                        <a href="item.html">Industrial Revolution</a>
                      </h3>
                      <div class="card__author card__author--verified">
                        <img src="/images/seller5.jpg" alt="" />
                        <Link to="/author">@midinh</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Reserve price</span>
                          <span>1.11 ETH</span>
                        </div>

                        <button class="card__likes" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span>23</span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end card --> */}
                  </div>

                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- card --> */}
                    <div class="card">
                      <a href="item.html" class="card__cover">
                        <img src="/images/cover3.jpg" alt="" />
                      </a>
                      <h3 class="card__title">
                        <a href="item.html">I Love You</a>
                      </h3>
                      <div class="card__author card__author--verified">
                        <img src="/images/seller9.jpg" alt="" />
                        <Link to="/author">@nicky87</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Reserve price</span>
                          <span>0.99 ETH</span>
                        </div>

                        <button class="card__likes" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span>358</span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end card --> */}
                  </div>

                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- video card --> */}
                    <div class="card">
                      <a
                        href="item.html"
                        class="card__cover card__cover--video"
                      >
                        <img src="/images/cover2.jpg" alt="" />
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                        >
                          <path d="M21.53,7.15a1,1,0,0,0-1,0L17,8.89A3,3,0,0,0,14,6H5A3,3,0,0,0,2,9v6a3,3,0,0,0,3,3h9a3,3,0,0,0,3-2.89l3.56,1.78A1,1,0,0,0,21,17a1,1,0,0,0,.53-.15A1,1,0,0,0,22,16V8A1,1,0,0,0,21.53,7.15ZM15,15a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V9A1,1,0,0,1,5,8h9a1,1,0,0,1,1,1Zm5-.62-3-1.5V11.12l3-1.5Z" />
                        </svg>
                      </a>
                      <h3 class="card__title">
                        <a href="item.html">Walking on Air</a>
                      </h3>
                      <div class="card__author">
                        <img src="/images/seller10.jpg" alt="" />
                        <Link to="/author">@redalert</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Reserve price</span>
                          <span>1.63 ETH</span>
                        </div>

                        <button class="card__likes" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span>90</span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end video card --> */}
                  </div>

                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- card --> */}
                    <div class="card">
                      <a href="item.html" class="card__cover">
                        <img src="/images/cover1.jpg" alt="" />
                        <span class="card__time">15 minutes left</span>
                      </a>
                      <h3 class="card__title">
                        <a href="item.html">Tranquility</a>
                      </h3>
                      <div class="card__author">
                        <img src="/images/seller11.jpg" alt="" />
                        <Link to="/author">@aaarthur</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Current price</span>
                          <span>2.55 ETH</span>
                        </div>

                        <button class="card__likes" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span>64</span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end card --> */}
                  </div>
                </div>

                {/* <!-- paginator --> */}
                <div class="row row--grid">
                  <div class="col-12">
                    <div class="paginator">
                      <span class="paginator__pages">9 from 169</span>

                      <ul class="paginator__list">
                        <li>
                          <a href="/">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                            >
                              <path d="M17,11H9.41l3.3-3.29a1,1,0,1,0-1.42-1.42l-5,5a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l5,5a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H17a1,1,0,0,0,0-2Z" />
                            </svg>
                          </a>
                        </li>
                        <li class="active">
                          <a href="/">1</a>
                        </li>
                        <li>
                          <a href="/">2</a>
                        </li>
                        <li>
                          <a href="/">3</a>
                        </li>
                        <li>
                          <a href="/">4</a>
                        </li>
                        <li>
                          <a href="/">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                            >
                              <path d="M17.92,11.62a1,1,0,0,0-.21-.33l-5-5a1,1,0,0,0-1.42,1.42L14.59,11H7a1,1,0,0,0,0,2h7.59l-3.3,3.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l5-5a1,1,0,0,0,.21-.33A1,1,0,0,0,17.92,11.62Z" />
                            </svg>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                {/* <!-- end paginator --> */}
              </div>

              <div class="tab-pane fade" id="tab-3" role="tabpanel">
                <div class="row row--grid">
                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- card --> */}
                    <div class="card">
                      <a href="item.html" class="card__cover">
                        <img src="/images/cover3.jpg" alt="" />
                        <span class="card__time">an hour left</span>
                      </a>
                      <h3 class="card__title">
                        <a href="item.html">Walking on Air</a>
                      </h3>
                      <div class="card__author">
                        <img src="/images/seller5.jpg" alt="" />
                        <Link to="/author">@nickname</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Current price</span>
                          <span>4.89 ETH</span>
                        </div>

                        <button class="card__likes" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span>189</span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end card --> */}
                  </div>

                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- card --> */}
                    <div class="card">
                      <a href="item.html" class="card__cover">
                        <img src="/images/cover2.jpg" alt="" />
                      </a>
                      <h3 class="card__title">
                        <a href="item.html">
                          Les Immortels, the Treachery of Artificial Shadows
                        </a>
                      </h3>
                      <div class="card__author card__author--verified">
                        <img src="/images/seller3.jpg" alt="" />
                        <Link to="/author">@neo</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Reserve price</span>
                          <span>2.61 ETH</span>
                        </div>

                        <button class="card__likes" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span>702</span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end card --> */}
                  </div>

                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- carousel card --> */}
                    <div class="card">
                      <a href="item.html" class="card__cover">
                        <img src="/images/cover1.jpg" alt="" />
                      </a>
                      <h3 class="card__title">
                        <a href="/">To Infinity And Beyond</a>
                      </h3>
                      <div class="card__author card__author--verified">
                        <img src="/images/seller2.jpg" alt="" />
                        <Link to="/author">@johndoe</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Reserve price</span>
                          <span>5.04 ETH</span>
                        </div>

                        <button class="card__likes" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span></span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end carousel card --> */}
                  </div>

                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- card --> */}
                    <div class="card">
                      <a href="/" class="card__cover">
                        <img src="/images/cover4.jpg" alt="" />
                      </a>
                      <h3 class="card__title">
                        <a href="/">Flowers in Concrete (Modal)</a>
                      </h3>
                      <div class="card__author">
                        <img src="/images/seller4.jpg" alt="" />
                        <Link to="/author">@min1max</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Reserve price</span>
                          <span>3.19 ETH</span>
                        </div>

                        <button
                          class="card__likes card__likes--active"
                          type="button"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span>37</span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end card --> */}
                  </div>

                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- card --> */}
                    <div class="card">
                      <a href="item.html" class="card__cover">
                        <img src="/images/cover5.jpg" alt="" />
                      </a>
                      <h3 class="card__title">
                        <a href="item.html">Industrial Revolution</a>
                      </h3>
                      <div class="card__author card__author--verified">
                        <img src="/images/seller5.jpg" alt="" />
                        <Link to="/author">@midinh</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Reserve price</span>
                          <span>1.11 ETH</span>
                        </div>

                        <button class="card__likes" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span>23</span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end card --> */}
                  </div>

                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- card --> */}
                    <div class="card">
                      <a href="item.html" class="card__cover">
                        <img src="/images/cover6.jpg" alt="" />
                      </a>
                      <h3 class="card__title">
                        <a href="item.html">I Love You</a>
                      </h3>
                      <div class="card__author card__author--verified">
                        <img src="/images/seller9.jpg" alt="" />
                        <Link to="/author">@nicky87</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Reserve price</span>
                          <span>0.99 ETH</span>
                        </div>

                        <button class="card__likes" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span>358</span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end card --> */}
                  </div>

                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- video card --> */}
                    <div class="card">
                      <a
                        href="item.html"
                        class="card__cover card__cover--video"
                      >
                        <img src="/images/cover7.jpg" alt="" />
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                        >
                          <path d="M21.53,7.15a1,1,0,0,0-1,0L17,8.89A3,3,0,0,0,14,6H5A3,3,0,0,0,2,9v6a3,3,0,0,0,3,3h9a3,3,0,0,0,3-2.89l3.56,1.78A1,1,0,0,0,21,17a1,1,0,0,0,.53-.15A1,1,0,0,0,22,16V8A1,1,0,0,0,21.53,7.15ZM15,15a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V9A1,1,0,0,1,5,8h9a1,1,0,0,1,1,1Zm5-.62-3-1.5V11.12l3-1.5Z" />
                        </svg>
                      </a>
                      <h3 class="card__title">
                        <a href="item.html">Walking on Air</a>
                      </h3>
                      <div class="card__author">
                        <img src="/images/seller2.jpg" alt="" />
                        <Link to="/author">@redalert</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Reserve price</span>
                          <span>1.63 ETH</span>
                        </div>

                        <button class="card__likes" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span>90</span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end video card --> */}
                  </div>

                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- card --> */}
                    <div class="card">
                      <a href="item.html" class="card__cover">
                        <img src="/images/cover8.jpg" alt="" />
                      </a>
                      <h3 class="card__title">
                        <a href="item.html">Tranquility</a>
                      </h3>
                      <div class="card__author">
                        <img src="/images/seller11.jpg" alt="" />
                        <Link to="/author">@aaarthur</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Reserve price</span>
                          <span>2.55 ETH</span>
                        </div>

                        <button class="card__likes" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span>64</span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end card --> */}
                  </div>
                </div>

                {/* <!-- paginator --> */}
                <div class="row row--grid">
                  <div class="col-12">
                    <div class="paginator">
                      <span class="paginator__pages">9 from 169</span>

                      <ul class="paginator__list">
                        <li>
                          <a href="/">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                            >
                              <path d="M17,11H9.41l3.3-3.29a1,1,0,1,0-1.42-1.42l-5,5a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l5,5a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H17a1,1,0,0,0,0-2Z" />
                            </svg>
                          </a>
                        </li>
                        <li class="active">
                          <a href="/">1</a>
                        </li>
                        <li>
                          <a href="/">2</a>
                        </li>
                        <li>
                          <a href="/">3</a>
                        </li>
                        <li>
                          <a href="/">4</a>
                        </li>
                        <li>
                          <a href="/">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                            >
                              <path d="M17.92,11.62a1,1,0,0,0-.21-.33l-5-5a1,1,0,0,0-1.42,1.42L14.59,11H7a1,1,0,0,0,0,2h7.59l-3.3,3.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l5-5a1,1,0,0,0,.21-.33A1,1,0,0,0,17.92,11.62Z" />
                            </svg>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                {/* <!-- end paginator --> */}
              </div>

              <div class="tab-pane fade" id="tab-4" role="tabpanel">
                <div class="row row--grid">
                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- card --> */}
                    <div class="card">
                      <a href="item.html" class="card__cover">
                        <img src="/images/cover7.jpg" alt="" />
                      </a>
                      <h3 class="card__title">
                        <a href="item.html">Walking on Air</a>
                      </h3>
                      <div class="card__author">
                        <img src="/images/seller5.jpg" alt="" />
                        <Link to="/author">@nickname</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Reserve price</span>
                          <span>4.89 ETH</span>
                        </div>

                        <button class="card__likes" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span>189</span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end card --> */}
                  </div>

                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- card --> */}
                    <div class="card">
                      <a href="item.html" class="card__cover">
                        <img src="/images/cover6.jpg" alt="" />
                        <span class="card__time">15 minutes left</span>
                      </a>
                      <h3 class="card__title">
                        <a href="item.html">
                          Les Immortels, the Treachery of Artificial Shadows
                        </a>
                      </h3>
                      <div class="card__author card__author--verified">
                        <img src="/images/seller3.jpg" alt="" />
                        <Link to="/author">@neo</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Current price</span>
                          <span>2.61 ETH</span>
                        </div>

                        <button class="card__likes" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span>702</span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end card --> */}
                  </div>

                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- carousel card --> */}
                    <div class="card">
                      <a href="item.html" class="card__cover">
                        <img src="/images/cover8.jpg" alt="" />
                      </a>
                      <h3 class="card__title">
                        <a href="/">To Infinity And Beyond</a>
                      </h3>
                      <div class="card__author card__author--verified">
                        <img src="/images/seller2.jpg" alt="" />
                        <Link to="/author">@johndoe</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Reserve price</span>
                          <span>5.04 ETH</span>
                        </div>

                        <button class="card__likes" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span></span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end carousel card --> */}
                  </div>

                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- card --> */}
                    <div class="card">
                      <a href="/" class="card__cover">
                        <img src="/images/cover5.jpg" alt="" />
                      </a>
                      <h3 class="card__title">
                        <a href="/">Flowers in Concrete (Modal)</a>
                      </h3>
                      <div class="card__author">
                        <img src="/images/seller4.jpg" alt="" />
                        <Link to="/author">@min1max</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Reserve price</span>
                          <span>3.19 ETH</span>
                        </div>

                        <button
                          class="card__likes card__likes--active"
                          type="button"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span>37</span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end card --> */}
                  </div>

                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- card --> */}
                    <div class="card">
                      <a href="item.html" class="card__cover">
                        <img src="/images/cover4.jpg" alt="" />
                      </a>
                      <h3 class="card__title">
                        <a href="item.html">Industrial Revolution</a>
                      </h3>
                      <div class="card__author card__author--verified">
                        <img src="/images/seller5.jpg" alt="" />
                        <Link to="/author">@midinh</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Reserve price</span>
                          <span>1.11 ETH</span>
                        </div>

                        <button class="card__likes" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span>23</span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end card --> */}
                  </div>

                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- card --> */}
                    <div class="card">
                      <a href="item.html" class="card__cover">
                        <img src="/images/cover3.jpg" alt="" />
                      </a>
                      <h3 class="card__title">
                        <a href="item.html">I Love You</a>
                      </h3>
                      <div class="card__author card__author--verified">
                        <img src="/images/seller9.jpg" alt="" />
                        <Link to="/author">@nicky87</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Reserve price</span>
                          <span>0.99 ETH</span>
                        </div>

                        <button class="card__likes" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span>358</span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end card --> */}
                  </div>

                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- video card --> */}
                    <div class="card">
                      <a
                        href="item.html"
                        class="card__cover card__cover--video"
                      >
                        <img src="/images/cover2.jpg" alt="" />
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                        >
                          <path d="M21.53,7.15a1,1,0,0,0-1,0L17,8.89A3,3,0,0,0,14,6H5A3,3,0,0,0,2,9v6a3,3,0,0,0,3,3h9a3,3,0,0,0,3-2.89l3.56,1.78A1,1,0,0,0,21,17a1,1,0,0,0,.53-.15A1,1,0,0,0,22,16V8A1,1,0,0,0,21.53,7.15ZM15,15a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V9A1,1,0,0,1,5,8h9a1,1,0,0,1,1,1Zm5-.62-3-1.5V11.12l3-1.5Z" />
                        </svg>
                      </a>
                      <h3 class="card__title">
                        <a href="item.html">Walking on Air</a>
                      </h3>
                      <div class="card__author">
                        <img src="/images/seller10.jpg" alt="" />
                        <Link to="/author">@redalert</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Reserve price</span>
                          <span>1.63 ETH</span>
                        </div>

                        <button class="card__likes" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span>90</span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end video card --> */}
                  </div>

                  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                    {/* <!-- card --> */}
                    <div class="card">
                      <a href="item.html" class="card__cover">
                        <img src="/images/cover1.jpg" alt="" />
                      </a>
                      <h3 class="card__title">
                        <a href="item.html">Tranquility</a>
                      </h3>
                      <div class="card__author">
                        <img src="/images/seller11.jpg" alt="" />
                        <Link to="/author">@aaarthur</Link>
                      </div>
                      <div class="card__info">
                        <div class="card__price">
                          <span>Reserve price</span>
                          <span>2.55 ETH</span>
                        </div>

                        <button class="card__likes" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z" />
                          </svg>
                          <span>64</span>
                        </button>
                      </div>
                    </div>
                    {/* <!-- end card --> */}
                  </div>
                </div>

                {/* <!-- paginator --> */}
                <div class="row row--grid">
                  <div class="col-12">
                    <div class="paginator">
                      <span class="paginator__pages">9 from 169</span>

                      <ul class="paginator__list">
                        <li>
                          <a href="/">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                            >
                              <path d="M17,11H9.41l3.3-3.29a1,1,0,1,0-1.42-1.42l-5,5a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l5,5a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H17a1,1,0,0,0,0-2Z" />
                            </svg>
                          </a>
                        </li>
                        <li class="active">
                          <a href="/">1</a>
                        </li>
                        <li>
                          <a href="/">2</a>
                        </li>
                        <li>
                          <a href="/">3</a>
                        </li>
                        <li>
                          <a href="/">4</a>
                        </li>
                        <li>
                          <a href="/">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                            >
                              <path d="M17.92,11.62a1,1,0,0,0-.21-.33l-5-5a1,1,0,0,0-1.42,1.42L14.59,11H7a1,1,0,0,0,0,2h7.59l-3.3,3.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l5-5a1,1,0,0,0,.21-.33A1,1,0,0,0,17.92,11.62Z" />
                            </svg>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                {/* <!-- end paginator --> */}
              </div>
            </div>
            {/* <!-- end tabs content --> */}
          </div>
        </section>
      </div>
      {/* <!-- end explore --> */}
    </>
  );
}

export default Collectible;
